import { render, staticRenderFns } from "./Aste.vue?vue&type=template&id=4a3816b9&"
import script from "./Aste.vue?vue&type=script&lang=js&"
export * from "./Aste.vue?vue&type=script&lang=js&"
import style0 from "./Aste.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports